module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/stoichiometry/Activity1_b/species.json";';

}
return __p
}